import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '../context/context';
import type { Terms } from '../data-contract/terms';
import { termsSchema } from '../data-contract/terms';
import type { Pathname } from '../http-fetcher/http-fetcher';

export type TermsQueryResult = {
    readonly reloadTerms: () => Promise<void>;
    readonly termsQuery: UseQueryResult<Terms>;
};

export const useTermsQuery = (): TermsQueryResult => {
    const { applicationState, validatingCobrainerApiFetcher } = useContext(ApplicationContext);
    const pathname: Pathname = `/terms/latest`;

    const queryKey = [pathname, 'GET', applicationState.language.code];
    const termsQuery = useQuery({
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.get(termsSchema, {
                pathname,
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
        queryKey,
    });
    const queryClient = useQueryClient();
    const reloadTerms = (): Promise<void> => queryClient.invalidateQueries({ queryKey });

    return { reloadTerms, termsQuery };
};
